import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        name: Yup.string().required('This field is required'),
        ref_number: Yup.string().required('This field is required'),
        contact_number: Yup.string().required('This field is required'),
    });
}
